import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  Renderer2
} from '@angular/core';
import { DomController, IonContent } from '@ionic/angular';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Directive({
  selector: '[animationSegmentToolbar]'
})
export class AnimationSegmentToolbarDirective implements AfterViewInit {
  @Input() animationContent: IonContent;
  private toolbar: HTMLElement;
  private segment: Element;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private dom: DomController
  ) {}

  ngAfterViewInit() {
    this.toolbar = this.el.nativeElement;
    this.segment = this.toolbar.getElementsByClassName('segment-bar').item(0);
    const hasScrolledDown$ = this.animationContent.ionScroll.pipe(
      map(ev => ev.detail.scrollTop > 0),
      distinctUntilChanged()
    );
    hasScrolledDown$.subscribe(hasScrolledDown => {
      hasScrolledDown ? this.setBoxShadow() : this.removeBoxShadow();
    });
  }

  private setBoxShadow() {
    this.dom.write(() => {
      this.renderer.setStyle(
        this.toolbar,
        'box-shadow',
        ' 0 5px 4px -6px rgba(0, 0, 0, 0.64)'
      );
      this.renderer.setStyle(this.segment, 'border-bottom-width', '0');
    });
  }

  private removeBoxShadow() {
    this.dom.write(() => {
      this.renderer.setStyle(this.toolbar, 'box-shadow', null);
      this.renderer.setStyle(this.segment, 'border-bottom-width', '1px');
    });
  }
}
